import { trans } from '@spotahome/soyuz/client';
import { getDateAsUTC } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';
import { subDays, isAfter, formatDistanceToNow, parseISO } from 'date-fns';

const OUTDATED_AVAILABILITIES_THRESHOLD = 15;

const isDateUpdated = date => {
  const maxUpdatedDate = subDays(
    getDateAsUTC(new Date()),
    OUTDATED_AVAILABILITIES_THRESHOLD
  );
  return isAfter(getDateAsUTC(date), maxUpdatedDate);
};

export const getLatestAvailability = dateUpdated =>
  isDateUpdated(dateUpdated)
    ? `(${trans('listing.calendar.calendar_updated')} ${formatDistanceToNow(
        parseISO(dateUpdated)
      )})`
    : `(${trans('listing.calendar.calendar_outdated')})`;

export default {
  getLatestAvailability
};
